import React from "react";

export default function BlockchainStatusCard({ stats }) {
  if (!stats) return null;
  return (
    <div className="p-4 rounded-xl shadow-md bg-gray-900 text-white">
      <h2 className="text-xl font-semibold mb-2">🌐 Réseau : {stats.network}</h2>
      <p>Dernier bloc : {stats.latestBlock}</p>
      <p>Prix du gaz : {stats.gasPrice} Gwei</p>
      <p className={`mt-2 ${stats.status === "online" ? "text-green-400" : "text-red-400"}`}>
        Statut : {stats.status}
      </p>
    </div>
  );
}
